var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 44,
    viewBox: "0 0 54 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0002 0.666687H35.0002C31.9322 0.677302 29.0173 2.00842 27.0002 4.32002C24.983 2.00842 22.0681 0.677302 19.0002 0.666687H3.00016C1.5274 0.666687 0.333496 1.86059 0.333496 3.33335V38C0.333496 39.4728 1.5274 40.6667 3.00016 40.6667H17.9068C18.6064 40.6696 19.2768 40.9474 19.7735 41.44L20.8935 42.56C21.3902 43.0527 22.0606 43.3304 22.7602 43.3334H31.2402C31.9397 43.3304 32.6101 43.0527 33.1068 42.56L34.2268 41.44C34.7235 40.9474 35.3939 40.6696 36.0935 40.6667H51.0002C52.4729 40.6667 53.6668 39.4728 53.6668 38V3.33335C53.6668 1.86059 52.4729 0.666687 51.0002 0.666687ZM24.3335 34.1067C22.713 33.1667 20.8735 32.67 19.0002 32.6667H5.66683V6.00002H19.0002C21.9457 6.00002 24.3335 8.38783 24.3335 11.3334V34.1067ZM35.0002 32.6667H48.3335V6.00002H35.0002C32.0546 6.00002 29.6668 8.38783 29.6668 11.3334V34.1067C31.2873 33.1667 33.1268 32.67 35.0002 32.6667Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.73b68c10eee941a25f28c60485ae775f.svg";
export { ForwardRef as ReactComponent };